<template>
  <div class="question">
    <p class="question-txt">{{questionData.question}}</p>
    <p class="instructions mb-40">{{questionData.instructions}}</p>

    <div class="slider-flavors" v-for="(question, index) in questionData.questions" :key="index">
      <div class="flavor-title">{{ question.title }}</div>
      <div class="slider-inner">
        <el-slider
          v-model="questionData.questions[index].value"
          :step="1"
          :min="0"
          :max="4"
          :show-tooltip="false"
          @change="updateStore"
          >
        </el-slider>
        <div class="slider__stops-container">
          <div class="slider-stop"></div>
          <div class="slider-stop"></div>
          <div class="slider-stop"></div>
          <div class="slider-stop"></div>
          <div class="slider-stop"></div>
        </div>
      </div>

      <div class="slider__labels">
        <div class="" v-for="(label, i) in question.labels" :key="i">
          <div class="title">{{ label }}</div>
        </div>
      </div>
    </div>

    <div class="question-footer">
      <Btn class="results-btn" type="primary-orange" theme="white" :hasIcon="false" @click="showResults">View your results</Btn>
    </div>
  </div>
</template>

<script>
import { Slider } from 'element-ui'
import Btn from '@/components/Btn'

export default {
  name: 'Question4',
  metaInfo() {
   // if no subcomponents specify a metaInfo.title, this title will be used
   return {
     title: 'Examine your eating',
     titleTemplate: ' %s - Question 4'
   }
  },
  components: {
    'el-slider': Slider,
    Btn
  },
  data() {
    return {

    }
  },
  computed: {
    questionData() {
      return this.$store.state.DietImpact.questions[3]
    }
  },
  methods: {
    showResults() {
      this.$store.commit('DietImpact/SHOW_RESULTS')
    },
    updateStore() {
      this.$store.commit('DietImpact/UPDATE_FLAVORS', this.questionData.questions)
    }
  }
}
</script>

<style lang="scss">
  @import '../assets/styles/vars';
  .slider-flavors {
    margin-bottom: 30px;
    position: relative;
    .flavor-title {
      font-family: $fPrimary;
      font-weight: $fwSemiBold;
      font-size: 14px;
      line-height: 17px;
      margin-bottom: 20px;
    }
    .slider-inner {
      position: relative;
      margin: 0 auto;
      width: 93%;
    }
    .slider__stops-container {
      width: 100%;
      position: absolute;
      display: flex;
      top: 50%;
      transform: translateY(-50%);
      .slider-stop {
        height: 10px;
        width: 2px;
        background-color: #E6E6E6;
        position: absolute;
        top: 50%;
        transform: translate(0%, -50%);
        &:nth-of-type(2) {
          left: 25%;
          transform: translate(-25%, -50%);
        }
        &:nth-of-type(3) {
          left: 50%;
          transform: translate(-50%, -50%);
        }
        &:nth-of-type(4) {
          left: 75%;
          transform: translate(-75%, -50%);
        }
        &:nth-of-type(5) {
          left: 100%;
          transform: translate(-100%, -50%);
        }
      }
    }
    .slider__labels {
      width: 100%;
      font-family: $fSecondary;
      font-weight: $fwMed;
      font-size: 15px;
      line-height: 22px;
      > div {
        &:last-of-type {
          text-align: right;
        }
      }
    }
  }
  .results-btn {
    width: auto;
  }
</style>
